import Vue from "vue";
//import VueRouter from "vue-router";
import router from "./router/router.js";
import App from "./App.vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueSVGIcon from "vue-svgicon";

Vue.use(VueSVGIcon);

// Vue.use(VueRouter);

// const routes = [
//   { path: "/calculator", component: Form },
//   { path: "/", component: Home }
// ];

// const router = new VueRouter({
//   routes,
//   mode: "history"
// });

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  render: h => h(App)
});

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/sw.js")
    .then(function(registration) {
      var serviceWorker;

      if (registration.installing) {
        serviceWorker = registration.installing;
        // console.log("[REG SW] installing");
      } else if (registration.waiting) {
        serviceWorker = registration.waiting;
        // console.log("[REG SW] waiting");
      } else if (registration.active) {
        serviceWorker = registration.active;
        // console.log("[REG SW] active");
      }

      if (serviceWorker) {
        // console.log("state", serviceWorker.state);
        serviceWorker.addEventListener("statechange", function() {
          // console.log("statechange", e.target.state);
        });
      }

      return navigator.serviceWorker.ready;
    })
    .catch(function() {
      // Something went wrong during registration. The service-worker.js file
      // might be unavailable or contain a syntax error.
    });
} else {
  // The current browser doesn't support service workers.
}
